import {withFormsy} from 'formsy-react';
import React, {Component} from 'react';

class Radio extends Component {

    changeValue = value => {
        this.props.setValue(value);
    };

    render()
    {
        let props = this.props;

        const errorMessage = props.getErrorMessage();

        let className = props.className || '';
        className += props.showRequired() ? ' required ' : '';

        className += !props.isValid() && props.isFormSubmitted() ? 'text-danger' : '';

        let inputClassName = !props.isValid() && props.isFormSubmitted() ? 'is-invalid' : '';


        return (
            <div className={'form-group ' + className}>
                {props.label !== false && (
                    <label className="col-form-label"
                           data-required={props.required}>
                        {props.label || 'Please select an option'}
                    </label>
                )}

                {props.options.map(({label, value, disabled}, index) => {
                    let radioId = props.name + "-radio-" + value;
                    return (
                        <div key={radioId}
                             className={"form-check " + ((props.disabled || disabled) && "disabled-check")}>

                            <input
                                type="radio"
                                className={"form-check-input " + inputClassName}
                                name={props.name}
                                id={radioId}
                                required={props.required}
                                disabled={props.disabled || disabled}
                                onChange={event => this.changeValue(value)}
                                checked={props.value === value}/>
                            <label id={"radio-input-"+ value} className="form-check-label"
                                   htmlFor={radioId}>
                                {label}
                            </label>


                        </div>
                    )
                })}
                {errorMessage && (
                    <span className={'invalid-feedback'}>
                        {errorMessage}
                    </span>
                )}
            </div>
        )
    }
}

const RadioInput = withFormsy(Radio);

export default RadioInput;
